import React from 'react';
import { debounce, get } from 'lodash';
import { string, array, bool, func } from 'prop-types';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { onPickerSearchAttempt } from '../../graphql/getPickers';
import { getUserStatus } from '../../../utils/misc';
import { FormSelect, FlexContainer, FormikSelect, Loading, Button, ConditionalRender } from '../../common';

class UserSearchSelect extends React.Component {
    constructor (props) {
        super(props);
        this.lastFetchId = 0;
        this._fetchUser = debounce(this._fetchUser, 500);
    }

    state = {
        data: [],
        value: [],
        fetching: false,
        disabled: false
    }

    _resolveUserName = (data) => ({
        label: `${get(data, 'firstName', '-')} ${get(data, 'lastName', '-')} - ${get(data, 'email')} - ${get(getUserStatus(), `${get(data, 'status')}.value`, 'Desconectado')}`,
        value: get(data, 'id')
    })

    _resolveId = (data) => get(data, 'id')

    _fetchUser = (client, value) => {
        const filterFields = ['firstName', 'lastName', 'email', 'document'];
        this.setState({ data: [], fetching: true });
        onPickerSearchAttempt(client, filterFields.map((field) => ({ field, value })))
            .then(({ data }) => {
                const response = data.map((item) => ({ text: this._resolveUserName(item), value: this._resolveId(item) }));
                this.setState({ data: response, fetching: false });
            });
    }

    handleSubmit = ({ selectedPicker }, formikBag) => {
        const { onSubmit } = this.props;
        onSubmit(selectedPicker, formikBag);
    }

    handleReset = () => {
        const { onReset } = this.props;
        onReset();
    }

    _formGenerateValidationSchema = (fields) => {
        return Yup.object().shape({
            selectedPicker: Yup.object().shape({
                value: Yup.string().required()
            })
        });
    }

    _toggleDisable = () => this.setState({ disabled: !this.state.disabled })

    render () {
        const { data, loading, defaultValue, label, insideModal, onChange, value, placeholder, onChangeSelectAll, width, salesChannelId } = this.props;
        const options = (data || []).map(this._resolveUserName);
        if (!insideModal) {
            return (
                <FormSelect
                    name='selectedPicker'
                    autoComplete
                    activateOptionAll
                    label={label}
                    options={options}
                    defaultValue={options}
                    onChange={onChange}
                    onChangeSelectAll={onChangeSelectAll}
                    value={value}
                    placeholder={placeholder}
                    width={width}
                    fromUserSelect
                />
            );
        }
        return (
            <FlexContainer direction='column' flex={1} >
                <Loading loading={loading}>
                    <ConditionalRender condition={!loading}>
                        <Formik
                            enableReinitialize
                            onSubmit={this.handleSubmit}
                            onReset={this.handleReset}
                            validationSchema={this._formGenerateValidationSchema}
                            initialValues={{ selectedPicker: get(defaultValue, 'id') && this._resolveUserName(defaultValue) }}
                            render={({ handleSubmit, handleReset, isValid, isSubmitting }) => (
                                <Form onSubmit={handleSubmit} onReset={handleReset}>
                                    <FlexContainer direction='column' justify='space-between' style={{ height: insideModal ? 150 : 'auto' }}>
                                        <Field
                                            fromUserSelect
                                            salesChannelId={salesChannelId}
                                            name='selectedPicker'
                                            component={FormikSelect}
                                            autoComplete
                                            label={label}
                                            options={options}
                                            placeholder='Ingrese (nombre, apellido o email)'
                                        />
                                        { insideModal && <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                                            <Button
                                                link
                                                text='btn.action.cancel'
                                                disabled={loading || isSubmitting}
                                                htmlType='reset'
                                                width={100}
                                            />
                                            <Button
                                                disabled={loading || isSubmitting || !isValid}
                                                loading={loading || isSubmitting}
                                                htmlType='submit'
                                                text='btn.action.confirm'
                                                width={100}
                                            />
                                        </FlexContainer> }
                                    </FlexContainer>
                                </Form>
                            )}
                        />
                    </ConditionalRender>
                </Loading>
            </FlexContainer>
        );
    }
}

UserSearchSelect.propTypes = {
    defaultValue: string,
    data: array,
    loading: bool,
    onSubmit: func,
    onReset: func,
    label: string,
    insideModal: bool,
    onChangeSelectAll: func,
    salesChannelId: string
};

UserSearchSelect.defaultProps = {
    label: 'Shopper',
    insideModal: false,
    onSubmit: () => null,
    onReset: () => null,
    onChangeSelectAll: () => {},
    salesChannelId: ''
};

export default (props) =>
    <UserSearchSelect data={[]} {...props} />;
